import type { Branch, BranchId } from "~/branching/model/branch";
import type { CommitId } from "~/branching/model/commit";

import { type CommitSnapshotSource, toCommit } from "./to-commit";

export type BranchTagSource = {
  id: string;
  tag: string;
  snapshotId: string;
  archiveStatus?: string;
  isArchived?: boolean;
};

export function toBranch(
  tag: BranchTagSource,
  headSnapshot: CommitSnapshotSource,
  defaultBranchId: string | null,
  headCommitRevisionId?: string,
): Branch {
  return {
    id: tag.id as BranchId,
    name: tag.tag,
    headCommitId: tag.snapshotId as CommitId,
    headCommitRevisionId,
    headCommit: toCommit(headSnapshot),
    isDefault: defaultBranchId !== null && tag.id === defaultBranchId,
    isArchived: tag.isArchived ?? tag.archiveStatus?.toLowerCase() === "archived",
  };
}
